import React from 'react';
import classNames from 'classnames';
import {Input as UiInput} from 'semantic-ui-react';

export const Input = (props: any) => {
  const {
    input,
    placeholder,
    meta,
    disabled,
    maxLength,
    outline,
    dark,
    autocomplete,
    label,
    labelPosition,
    ...rest
  } = props;

  return (
    <div className="gc__input">
      <UiInput
        className={classNames({
          outline: outline,
          dark: dark,
        })}
        label={label ? label : false}
        labelPosition={labelPosition ? labelPosition : 'right'}
        autoComplete={autocomplete || 'off'}
        placeholder={placeholder}
        maxLength={maxLength || 30}
        disabled={disabled || meta.submitting}
        loading={false}
        name={input.name}
        value={input.value}
        onChange={input.onChange}
        {...rest}
      />
      {meta.touched &&
        ((meta.error && <div className="form__error">{meta.error}</div>) ||
          (meta.warning && (
            <div className="form__warning">{meta.warning}</div>
          )))}
    </div>
  );
};
